export default "__VITE_ASSET__f83d06b8__"